import { concepts, lessons, sentences, words } from '../data/foundations'
import type { ValidationIssue } from './curriculum'

export const validateDecodability = (): ValidationIssue[] => {
  const issues: ValidationIssue[] = []
  const orderByConcept = new Map(concepts.map((concept) => [concept.id, concept.order]))
  const wordById = new Map(words.map((word) => [word.id, word]))

  lessons.filter((lesson) => lesson.mode === 'decodable').forEach((lesson) => {
    const lessonOrder = orderByConcept.get(lesson.conceptId) ?? -1
    lesson.wordIds.forEach((wordId) => {
      const word = wordById.get(wordId)
      if (!word) return
      word.mapping.forEach((mapping) => {
        const mappingConceptId = word.decodableAfterConcepts.find((id) => concepts.find((concept) => concept.id === id)?.mappingIds.includes(mapping.mappingId))
        const requiredOrder = mappingConceptId ? (orderByConcept.get(mappingConceptId) ?? Number.POSITIVE_INFINITY) : Number.POSITIVE_INFINITY
        if (requiredOrder > lessonOrder) {
          issues.push({ level: 'error', code: 'FUTURE_MAPPING', message: `${word.spelling} in ${lesson.id}: unknown ${mapping.grapheme}; requires ${mappingConceptId ?? mapping.mappingId}` })
        }
      })
    })
  })

  words.filter((word) => word.isPseudoWord).forEach((word) => {
    const introOrder = orderByConcept.get(word.introducedAtConceptId) ?? -1
    word.decodableAfterConcepts.forEach((id) => {
      if ((orderByConcept.get(id) ?? Number.POSITIVE_INFINITY) > introOrder) issues.push({ level: 'error', code: 'PSEUDO_WORD_FUTURE_MAPPING', message: `${word.spelling} uses future concept ${id}` })
    })
  })

  sentences.forEach((sentence) => {
    const stageConceptOrders = concepts.filter((concept) => concept.stage <= sentence.introducedAtStage).map((concept) => concept.order)
    const maxOrder = Math.max(...stageConceptOrders)
    sentence.wordIds.forEach((wordId) => wordById.get(wordId)?.decodableAfterConcepts.forEach((id) => {
      if ((orderByConcept.get(id) ?? Number.POSITIVE_INFINITY) > maxOrder) issues.push({ level: 'error', code: 'SENTENCE_FUTURE_MAPPING', message: `${sentence.id} uses ${wordId} before ${id}` })
    }))
  })
  return issues
}

